import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    curDate: null,
}

export const fetchCurrentDate = createAsyncThunk('config/get-current-date-time', async (postdata = null, { rejectWithValue }) => {
    try {
        const response = await newAxiosInstance.get(BASE_URL + '/api/ConfigItem/get-current-date-time')
        return response.data
    }catch(err){
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const Categories = createSlice({
    name: 'pettycashcategory',
    initialState,
    reducers: {
        resetState: (state, action) => {
            return initialState;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCurrentDate.fulfilled, (state, action) => {
                state.curDate = action.payload
            })
    }
})

export const getCurdate = (state) => state.pettycashcategory.curDate;

export const PettyCashCategoryActions = Categories.actions

export default Categories.reducer